import axios from '@/config/api.request'
import qs from 'qs'

export default {
  // 查询SOL价格
  getSOLPrice () {
    return axios.request({
      url: '/forward/public/get',
      method: 'get',
      params: { 'url':'https://web-api.coinmarketcap.com/v1/cryptocurrency/ohlcv/latest?id=5426' }
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/request.js